<template>
  <div class="service-booking-summary">
    <div
      v-if="isSpaClosedByTemp"
      class="service-booking-summary__row--closed-by-temp"
    >
      <div class="service-booking-summary__row">
        <CheckListItem>
          <p class="service-booking-summary__row__text">
            <Lang by-key="summary-spa-closedtemp" />
          </p>
        </CheckListItem>
      </div>
    </div>

    <div v-if="isAvailable">
      <div class="service-booking-summary__row">
        <CheckListItem>
          <p class="service-booking-summary__row__text">
            <Lang by-key="summary-voucher-pdf" />
          </p>
        </CheckListItem>
      </div>
      <div class="service-booking-summary__row">
        <CheckListItem>
          <p
            v-if="isChristmas"
            class="service-booking-summary__row__text"
          >
            <Lang by-key="summary-change-refund-chrst" />
          </p>
          <p
            v-else
            class="service-booking-summary__row__text"
          >
            <Lang by-key="summary-change-refund" />
          </p>
        </CheckListItem>
      </div>
      <div
        v-if="daysToExpire || monthsToExpire"
        class="service-booking-summary__row"
      >
        <CheckListItem>
          <p class="service-booking-summary__row__text">
            <Lang
              v-if="monthsToExpire"
              by-key="summary-voucher-expirate-month"
              :params="{months: monthsToExpire}"
            />
            <Lang
              v-else-if="daysToExpire"
              by-key="summary-voucher-expirate-day"
              :params="{days: daysToExpire}"
            />
          </p>
        </CheckListItem>
      </div>
      <div
        v-if="isRefundableLabelDisplayed"
        class="service-booking-summary__row"
      >
        <CheckListItem>
          <p class="service-booking-summary__row__text">
            <Lang by-key="summary-expiration" />
          </p>
        </CheckListItem>
      </div>
    </div>

    <div
      v-else
      class="service-booking-summary__not-available"
    >
      <p><Lang by-key="summary-service-unavailable" /></p>
    </div>
  </div>
</template>

<script lang="ts">
import CheckListItem from '../shared/CheckListItem.vue'
import CheckIcon from '../shared/icons/Check.icon.vue'

import config from '~/core/ts/server-config'

import { Spa } from '~/core/ts/entity/Spa'
import { Service } from '~/core/ts/entity/Service'

export default defineNuxtComponent({
  components: {
    CheckListItem,
    CheckIcon,
  },
  props: {
    isAvailable: {
      type: Boolean,
      required: true,
    },
    isRefundableLabelDisplayed: {
      type: Boolean,
      default: () => true,
    },
    isSpaClosedByTemp: {
      type: Boolean,
      default: () => true,
    },
    spa: {
      type: Object as PropType<Spa>,
      default: () => null,
    },
    service: {
      type: Object as PropType<Service>,
      required: true,
    },
  },
  setup(props) {
    const isChristmas = config.promos.isChristmas

    const daysToExpire = computed(() => {
      if (props.service.salesConfig.daysBeforeVoucherExpirate) {
        return props.service.salesConfig.daysBeforeVoucherExpirate
      }

      if (!props.spa) {
        return 0
      }

      const daysToExpire = props.spa.salesConfig.daysBeforeVoucherExpirate
      if (!daysToExpire) {
        return 0
      }

      return daysToExpire
    })

    const monthsToExpire = computed(() => Math.floor(daysToExpire.value / 30))

    return {
      isChristmas,

      daysToExpire,
      monthsToExpire,
    }
  },
})
</script>

<style lang="scss" scoped>
.service-booking-summary {
  &__row {

    &--closed-by-temp {
      @apply flex;
      @apply items-center;

      @apply pb-20p mb-20p;
      @apply border-b;
    }

    &__text {
      @apply text-spl-dark;
      @apply font-bold;
    }
  }

  &__not-available {
    @apply text-spl-acent-dark;
    @apply font-bold text-lg;
    @apply text-center;
  }
}
</style>
